import { render, staticRenderFns } from "./TFarmonTableHeader.vue?vue&type=template&id=7b70de90&"
import script from "./TFarmonTableHeader.vue?vue&type=script&lang=js&"
export * from "./TFarmonTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports